/**
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'jquery',
	'../common/LabeledValueView',
	'../../../preview/LiveWidgetPreview'
], function($, LabeledValueView, LiveWidgetPreview) {

	class KpiViewFactory {

		/**
		* @description Create a sparkline view
		* @function KpiViewFactory#createSparklineView
		* @public
		*
		* @param {Object} options Options for the LiveWidgetPreview view
		*/
		createSparklineView(options) {
			return new LiveWidgetPreview(options);
		}

		/**
		* @description Create a LabeledValue view
		* @function KpiViewFactory#createLabeledValueView
		* @public
		*
		* @param {Object} options Options for the LabeledValueView view
		*/
		createLabeledValueView(options) {
			return new LabeledValueView(options);
		}

	}
	return KpiViewFactory;
});
